import { ROUTE_PATHS } from "./RoutesPaths";

/** Auth pages whose main form block is vertically centered in the content column. */
const AUTH_CENTERED_FORM_PATHS = new Set([
  ROUTE_PATHS.login,
  ROUTE_PATHS.companyLogin,
  ROUTE_PATHS.clientLogin,
  ROUTE_PATHS.forgetPassword,
  ROUTE_PATHS.companyForgetPassword,
  ROUTE_PATHS.clientForgetPassword,
  ROUTE_PATHS.companyPendingApproval,
  ROUTE_PATHS.companyDeactivated,
  ROUTE_PATHS.resetPasswordSuccess,
  ROUTE_PATHS.companyResetPasswordSuccess,
  ROUTE_PATHS.clientResetPasswordSuccess,
  ROUTE_PATHS.clientResetPassword,
  ROUTE_PATHS.companyResetPassword,
  ROUTE_PATHS.companySignup,
  ROUTE_PATHS.companySignupContact,
  ROUTE_PATHS.companySignupOtp,
  ROUTE_PATHS.companySignupCompany,
  ROUTE_PATHS.clientSelectCompany,
]);

const AUTH_WIDE_CENTERED_FORM_PATHS = new Set([
  ROUTE_PATHS.clientSelectCompany,
]);

export const isAuthCenteredFormPath = (pathname) =>
  AUTH_CENTERED_FORM_PATHS.has(pathname);

export const isAuthWideCenteredFormPath = (pathname) =>
  AUTH_WIDE_CENTERED_FORM_PATHS.has(pathname);
